import React from "react";
import { CalendarView } from "@/layouts/calendar-view";
import { DebugPanel } from "@/components/DebugPanel";
import { AppointmentModal } from "@/components/custom/appointment-modal/appointment-modal";

/**
 * DashboardPage: Main protected dashboard content.
 * Renders only the main content; layout shell is provided by MainLayout.
 */
export default function DashboardPage() {
  return (
    <>
      <CalendarView />
      {/*{import.meta.env.DEV && <DebugPanel />}*/}
      <AppointmentModal />
    </>
  );
}
